<template>
  <div>
    <section class="box" v-if="datas">

      <!-- banner -->
      <template v-if="datas.focus && datas.focus_pics_is_show == 1" v-for="(item, index) in datas.focus">
        <div 
          class="banner" 
          v-if="index == 0"
          :key="index">
            <img :src="item.img">
        </div>
      </template>

      <div class="titNav">
        原厂正品 谨防假冒伪劣
      </div>

      <div class="form">
        <ul class="row">
          <li class="label">姓名:</li>
          <li class="value"><input type="text" v-model="form.name" /></li>
        </ul>
        <ul class="row">
          <li class="label">手机号:</li>
          <li class="value"><input type="tel" v-model="form.phone" maxlength="11" /></li>
        </ul>
        <ul class="row">
          <li class="label">医生姓名:</li>
          <li class="value"><input type="text" v-model="form.doctorName" /></li>
        </ul>
        <ul class="row">
          <li class="label">医疗机构名称:</li>
          <li class="value"><input type="text" v-model="form.companyName" /></li>
        </ul>
        <ul class="row">
          <li class="label">手术日期:</li>
          <li class="value"><input type="date" v-model="form.date" /></li>
        </ul>
        <ul class="row">
          <li class="label">
            <p style="font-size: 24rem;">咨询师12位识别码:</p>
            <p style="font-size: 22rem;">（若无，请忽略）</p>
          </li>
          <li class="value"><input type="text" v-model="form.idcode" maxlength="12" /></li>
        </ul>
      </div>

      <div class="text">
        <p>本查询仅可关联一个手机号码</p>
        <p>建议由患者输入本人手机号码</p>
      </div>
      
      <div class="btns">
        <div class="btn" @click="confirmHandle">点击验证</div>
        <div class="btn" @click="resetHandle">重置</div>
      </div>

      <div class="tips">士卓曼集团防伪查询系统包含以下品牌：士卓曼、安卓健、T-PLUS</div>

      <div class="footer">
        <img v-for="index in 3" :src="`/static/images/Normal25/f${index}.png`" />
      </div>
                
    </section>
    
    <K-AlertMsg :AlertMsg="AlertMsg" bg="#8bbd21" @AlertBack="AlertBack"></K-AlertMsg>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import AlertMsg from '@/components/AlertMsg.vue'
import mixin from '../mixins/mixin.js'
import { formatDate } from '@/hook/common.js'
export default {
  name: 'Normal25',
  mixins: [mixin],
  components: {
    'K-Loading': Loading,
    'K-AlertMsg': AlertMsg,
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      msg: '',
      datas: null,
      hintTxt: null,
      audioSrc: '',
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      form: {
        name: '',
        phone: '',
        doctorName: '',
        companyName: '',
        date: '',
        idcode: '',
      }
    }
  },
  created() {
    self = this;
    this.AdaptiveSizeNew();
    document.body.style.backgroundColor = "rgb(255, 255, 255)";
    document.title = "Document";  //设置页面标题

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  methods: {
    resetHandle(){
      Object.keys(this.form).forEach(key=>{
        this.form[key] = '';
      })
    },
    confirmHandle(){
      if(!this.form.name){
        this.AlertMsg.msg = '姓名不能为空';
        this.AlertMsg.state = true;
        return;
      }
      if(!this.form.phone){
        this.AlertMsg.msg = '手机号不能为空';
        this.AlertMsg.state = true;
        return;
      }
      if(!this.form.doctorName){
        this.AlertMsg.msg = '医生姓名不能为空';
        this.AlertMsg.state = true;
        return;
      }
      if(!this.form.companyName){
        this.AlertMsg.msg = '机构名称不能为空';
        this.AlertMsg.state = true;
        return;
      }
      if(!this.form.date){
        this.AlertMsg.msg = '手术日期不能为空';
        this.AlertMsg.state = true;
        return;
      }
      const params = {
        from: 'Normal25',
        name: this.datas.business.name,
        cid: this.datas.business.rootid,
        body: this.form.name,
        phone: this.form.phone,
        code: this.code,
        attr: JSON.stringify({...this.form}),
      }
      axios.post(this.GetServerUrl(1) + "feelback", params).then(res=>{
        let state = 2;
        if(res.data && res.data.code == 200){
          state = 1;
          this.datas.query_first_time = formatDate(new Date());
        }else{
          this.datas.query_first_time = res.data.meta.created_at;
        }
        localStorage.setItem("wwm_ref", JSON.stringify({ template: 'Normal25', data: this.datas }));
        localStorage.setItem(`wwm_Normal25_${this.code}`, state);
        this.$router.push({ path: `/Details?template=Normal25` }); // 模板路由跳转
      }).catch(err=>{
        console.error(err)
      });
    },
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.query_count = response.data.meta.query_count;  //查询次数
          datas.query_first_time = response.data.meta.query_first_time;  //查询时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码
          datas.code = self.code; //二维码

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    }
  }
}
</script>

<style scoped lang="scss">
$themeColor: #8bbd21;
.box{
  .banner{
    display: flex;
    padding: 40rem 0;
    align-items: center;
    justify-content: center;
    img{
      width: 350rem;
    }
  }

  .titNav{
    color: white;
    padding: 15rem 0;
    text-align: center;
    font-size: 30rem;
    background-color: $themeColor;
  }

  .form{
    gap: 30rem;
    display: flex;
    flex-direction: column;
    padding: 50rem 70rem 0 70rem;
    .row{
      display: flex;
      align-items: center;
      flex-direction: row;
      $labelWidth: 240rem;
      .label{
        font-size: 28rem;
        width: $labelWidth;
      }
      .value{
        width: calc(100% - $labelWidth);
        input{
          width: 100%;
          height: 70rem;
          font-size: 28rem;
          padding: 0 10rem;
          box-sizing: border-box;
          border: solid 3px $themeColor;
          background-color: white;
        }
      }
    }
  }

  .text{
    text-align: center;
    font-size: 30rem;
    margin-top: 50rem;
    p{
      padding-bottom: 5rem;
    }
  }

  .btns{
    gap: 20rem;
    margin-top: 50rem;
    color: white;
    display: flex;
    align-items: center;
    text-align: center;
    flex-direction: column;
    .btn{
      font-size: 30rem;
      width: 330rem;
      padding: 25rem 0;
      border-radius: 50rem;
      &:first-child{
        font-weight: bold;
        font-size: 35rem;
      }
    }

    :first-child{
      background-color: $themeColor;
    }
    :last-child{
      background-color: black;
    }
  }

  .tips{
    font-size: 22rem;
    text-align: center;
    margin: 20rem 0 30rem 0;
    transform: scale(.9);
  }

  .footer{
    gap: 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 200rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Normal25.vue